export default __webpack_public_path__ + "static/media/war-info-1.4a9af266.png";